import { img, readdy } from '@/utils/images';

export const newsHero = {
  title: '品牌动态',
  subtitle: 'NEWS & UPDATES',
  description: '了解颜轻至最新品牌资讯、市场拓展动态、培训赋能活动，感受品牌持续发展的活力与决心。',
};

export const categories = [
  { key: 'all', label: '全部' },
  { key: 'brand', label: '品牌新闻' },
  { key: 'training', label: '培训赋能' },
  { key: 'store', label: '门店动态' },
  { key: 'franchise', label: '招商资讯' },
  { key: 'health', label: '健康知识' },
];

export const articles = [
  {
    id: 1,
    title: '颜轻至2026夏季新品发布会圆满落幕，全新草本护理系列正式亮相',
    date: '2026-05-20',
    category: 'brand',
    summary: '5月18日，颜轻至在西安举办夏季新品发布会，正式推出全新草本护理系列产品。新品融合中医经络理论与现代生物科技，在原料配方和功效验证方面实现了重要突破。来自全国各地的合作伙伴、门店店长及行业媒体共同见证了这一重要时刻。',
    image: readdy('news-img-1'),
    featured: true,
    contentBlocks: [
      { type: 'text', value: '5月18日，颜轻至在西安举办夏季新品发布会，正式推出全新草本护理系列产品。新品融合中医经络理论与现代生物科技，在原料配方和功效验证方面实现了重要突破。来自全国各地的合作伙伴、门店店长及行业媒体共同见证了这一重要时刻。' },
      { type: 'image', value: readdy('news-block-1a'), alt: '草本护理系列新品展示' },
      { type: 'text', value: '本次发布的草本护理系列涵盖焕活精华、舒缓贴敷、调理浴包三大品类，所有产品均采用天然草本原料，经过严格的皮肤安全性测试与功效验证。产品研发团队历时18个月，走访了云南、四川、贵州等中草药主产区，精选了12味核心草本原料。' },
      { type: 'text', value: '发布会现场，颜轻至品牌创始人表示："草本护理系列的推出，是颜轻至在健康纤体领域深耕十余年的又一重要成果。我们始终坚持将传统中医智慧与现代科技相结合，为顾客提供安全、有效的健康管理方案。"' },
      { type: 'image', value: readdy('news-block-1b'), alt: '发布会现场盛况' },
      { type: 'text', value: '来自全国各地的200余位合作伙伴和行业媒体出席了发布会，现场设置了产品体验区，与会嘉宾亲身感受了新品的质地和功效。多位门店店长表示，新系列产品将进一步丰富门店的服务品类，为顾客提供更全面的健康护理选择。' },
    ],
  },
  {
    id: 2,
    title: '第三期店长训练营在郑州圆满结营，30余位店长完成系统化培训',
    date: '2026-05-12',
    category: 'training',
    summary: '为期一周的第三期店长训练营在郑州培训基地顺利结业。来自全国各地的30余位门店店长完成了涵盖产品知识、服务流程、门店管理、顾客维护等全方位系统化培训课程。',
    image: readdy('news-img-2'),
    featured: false,
    contentBlocks: [
      { type: 'text', value: '为期一周的第三期店长训练营在郑州培训基地顺利结业。来自全国各地的30余位门店店长完成了涵盖产品知识、服务流程、门店管理、顾客维护等全方位系统化培训课程。' },
      { type: 'text', value: '本期训练营在课程设置上进行了全面升级，新增了"数字化门店运营管理"和"顾客体验设计"两大模块。培训采用理论学习、案例分析、实操演练、门店参访相结合的方式，确保每位学员能够将所学知识直接应用到实际门店运营中。' },
      { type: 'image', value: readdy('news-block-2a'), alt: '店长实操训练现场' },
      { type: 'text', value: '训练营期间，学员们分组进行了门店运营模拟演练，从接待流程、体质评估、方案推荐到售后服务，全流程实战操作。总部资深培训师一对一指导，针对每位学员的薄弱环节进行针对性提升。' },
      { type: 'text', value: '结业典礼上，表现优异的6位店长获得了"金牌店长"荣誉称号。来自西安旗舰店的李店长在分享中表示："这次训练营让我对门店标准化运营有了更系统的认识，特别是顾客体验设计模块，对我启发很大。"' },
      { type: 'text', value: '据悉，第四期店长训练营将于7月在武汉举办，目前已有40余位店长预报名。' },
    ],
  },
  {
    id: 3,
    title: '颜轻至江西南昌红谷滩旗舰店盛大开业',
    date: '2026-05-05',
    category: 'store',
    summary: '南昌首家旗舰店在红谷滩核心商圈正式开业，门店面积320平方米，配备9间独立护理室和最新数字化健康管理系统。开业当日举办了健康体验开放日活动，吸引众多市民前来参观体验。',
    image: readdy('news-img-3'),
    featured: false,
    contentBlocks: [
      { type: 'text', value: '南昌首家旗舰店在红谷滩核心商圈正式开业，门店面积320平方米，配备9间独立护理室和最新数字化健康管理系统。开业当日举办了健康体验开放日活动，吸引众多市民前来参观体验。' },
      { type: 'text', value: '南昌红谷滩旗舰店位于红谷滩万达广场商圈核心位置，交通便利，周边配套成熟。门店延续颜轻至最新品牌标准设计，以米色和浅咖色为主色调，营造温暖、舒适、专业的服务氛围。' },
      { type: 'image', value: readdy('news-block-3a'), alt: '旗舰店护理室内部环境' },
      { type: 'text', value: '店内配备9间独立护理室，全部采用隔音设计，保障顾客隐私。每间护理室配备智能灯光控制系统和专业经络护理设备。门店还设有独立的体测评估室，引进最新的人体成分分析仪，可为顾客提供精准的身体数据检测。' },
      { type: 'text', value: '开业当日，门店举办了"健康体验开放日"活动，市民可免费体验体测评估和15分钟肩颈放松项目。活动吸引了周边社区和写字楼白领近300人次参与，现场签约会员60余人。' },
      { type: 'image', value: readdy('news-block-3b'), alt: '开业当日市民排队体验' },
      { type: 'text', value: '南昌旗舰店店长表示，门店将以"做南昌最专业的健康纤体服务机构"为目标，为江西地区的顾客带来高品质的健康管理服务体验。' },
    ],
  },
  {
    id: 4,
    title: '2026年第二季度区域经理战略会议召开，深化华中市场布局',
    date: '2026-04-28',
    category: 'franchise',
    summary: '颜轻至2026年第二季度区域经理战略会议在武汉召开。会议总结了一季度市场拓展成果，重点部署了华中地区城市合伙人计划，明确了新一季度的招商目标和区域保护政策。',
    image: readdy('news-img-4'),
    featured: false,
    contentBlocks: [
      { type: 'text', value: '颜轻至2026年第二季度区域经理战略会议在武汉召开。会议总结了一季度市场拓展成果，重点部署了华中地区城市合伙人计划，明确了新一季度的招商目标和区域保护政策。' },
      { type: 'text', value: '会议为期两天，全国各省区区域经理悉数到场。首日议程聚焦一季度业绩复盘，全国门店总体营收同比增长32%，其中华东和西南地区表现最为亮眼。新增门店23家，超额完成一季度拓展目标。' },
      { type: 'image', value: readdy('news-block-4a'), alt: '会议现场数据展示' },
      { type: 'text', value: '第二天的会议重点讨论了华中市场拓展战略。华中地区作为全国人口密集、消费潜力巨大的区域市场，被确定为2026年度重点拓展方向。会议确定了武汉、长沙、郑州、合肥四城市作为首批城市合伙人招募城市。' },
      { type: 'text', value: '关于区域保护政策，会议进一步明确了每个城市合伙人的专属区域保护范围，确保合伙人在授权区域内享有独家经营权。同时，总部将提供从选址评估、装修设计、人员培训到开业运营的全流程支持。' },
      { type: 'image', value: readdy('news-block-4b'), alt: '区域拓展战略讨论' },
      { type: 'text', value: '会议最后，各区域经理签署了二季度目标责任书，明确了各自的拓展指标和完成时间节点。' },
    ],
  },
  {
    id: 5,
    title: '春夏之交如何科学管理体重？颜轻至顾问分享三大健康法则',
    date: '2026-04-20',
    category: 'health',
    summary: '春夏之交是体重管理的关键窗口期。资深瘦身顾问孙伟华分享了饮食搭配、运动节律、作息调整三大健康管理法则，帮助大家在换季期间科学维护健康体重。',
    image: readdy('news-img-5'),
    featured: false,
    contentBlocks: [
      { type: 'text', value: '春夏之交是体重管理的关键窗口期。资深瘦身顾问孙伟华分享了饮食搭配、运动节律、作息调整三大健康管理法则，帮助大家在换季期间科学维护健康体重。' },
      { type: 'heading', value: '法则一：饮食搭配要"应季而食"' },
      { type: 'text', value: '春夏之交，气候由温转热，人体新陈代谢逐渐加快。孙顾问建议，此时应多食用富含膳食纤维的时令蔬菜，如芦笋、菠菜、芹菜等，搭配适量的优质蛋白，减少高油高糖食物的摄入。' },
      { type: 'image', value: readdy('news-block-5a'), alt: '应季健康食材搭配' },
      { type: 'text', value: '特别推荐"三色饮食法"：每餐保证有三种以上颜色的天然食材，绿色蔬菜提供维生素和纤维，黄色谷物提供持久能量，白色蛋白提供必需氨基酸。' },
      { type: 'heading', value: '法则二：运动节律要"循序渐进"' },
      { type: 'text', value: '随着天气转暖，户外运动的条件越来越好。孙顾问提醒，春季运动要循序渐进，不宜突然加大运动量。建议从每天快走30分钟开始，逐步增加运动时长和强度。' },
      { type: 'image', value: readdy('news-block-5b'), alt: '经络拉伸运动示范' },
      { type: 'text', value: '经络拉伸是颜轻至特别推荐的运动方式，每天早晚各做10分钟经络拉伸，可以帮助疏通经络、促进气血循环，对体重管理有辅助作用。' },
      { type: 'heading', value: '法则三：作息调整要"顺应自然"' },
      { type: 'text', value: '春夏之交昼长夜短，孙顾问建议顺应自然规律适当调整作息。保持早睡早起的习惯，确保每天7-8小时的优质睡眠。充足的睡眠有助于调节体内激素水平，对控制食欲和维持代谢有重要作用。' },
      { type: 'image', value: readdy('news-block-5c'), alt: '健康作息环境' },
      { type: 'text', value: '颜轻至始终倡导科学、健康、可持续的体重管理理念，而非追求短期快速减重。如果您想了解更多个性化体重管理方案，欢迎预约门店体验，我们的专业顾问将为您提供一对一的健康评估和方案定制服务。' },
    ],
  },
];